import { render } from "./productionCountries.vue?vue&type=template&id=23d4ba5e&scoped=true&ts=true"
import script from "./productionCountries.vue?vue&type=script&lang=ts"
export * from "./productionCountries.vue?vue&type=script&lang=ts"

import "./productionCountries.vue?vue&type=style&index=0&id=23d4ba5e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d4ba5e"]])

export default __exports__